exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".export-notification{\n    height: 20px;width: 20px;    margin-left: 20px;\n}\n.export-notification:hover{\n    cursor: pointer;\n}\n.successor{\n    width:18%;margin-left: 10px;\n}\n.c-btn.disabled {\n    background: #c2cfd6 !important;\n}\n.error{\n    color: red;\n    font-size: 13px;\n}\n.d-flex-column{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/node_modules/postcss-loader?{"ident":"postcss"}!/home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles